import { Group, TextInput, TextInputProps } from "@mantine/core"
import { TextLabelInput } from "./TextLabelInput"

type Props = TextInputProps & {
    label?: string
    placeholder?: string
}

export const NewTextInput = ({ label, placeholder, ...props }: Props) => (
    <Group noWrap>
        {label ?
            <TextLabelInput label={label}>
                <TextInput
                    placeholder={placeholder ?? 'Trade ID'}
                    classNames={{
                        input: 'newInput',
                        wrapper: 'newInputWrapper',
                    }}
                    {...props}
                />
            </TextLabelInput>
            : <TextInput
                placeholder={placeholder ?? 'Trade ID'}
                classNames={{
                    input: 'newInput',
                    wrapper: 'newInputWrapper',
                }}
                {...props}
            />}

    </Group>
)
